import { axiosBackendClient } from './client';

export type VisitDetailsUpdatePayload = {
  description?: string;
  documentsToAdd?: {
    filename: string;
    url: string;
    originalFilename?: string;
  }[];
  documentIdsToRemove?: string[];
};

/**
 * Owner-side edit of the visit "Dolegliwości" + attached documents.
 * Hand-rolled (not regenerated through woofwoof-api) because this endpoint
 * was added after the last client regen — matches the precedent set by
 * `visit-owner.ts` and `visit-profile-data.ts`.
 */
export const visitDetailsApi = {
  update: (visitId: string, payload: VisitDetailsUpdatePayload) =>
    axiosBackendClient.patch(`/api/visit/${visitId}/details`, payload),
};
